import { I18NText } from '@api/ChallengeClient';
import { I18n } from '@core/i18n';

/** Rendered via <img> rather than inline markup so admin-supplied SVG cannot execute. */
export const toDataUri = (svg: string) =>
    `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;

/** Falls back past the main language so a label set only in pl still shows. */
export const resolveRoleLabel = (label?: I18NText) =>
    (label &&
        (label[I18n.mainLanguageKey] || Object.values(label).find(Boolean))) ||
    '';
